// Helper for date formatting
export const formatDate = d => d ? new Date(d).toISOString().split('T')[0] : '';

export function LabeledSelect({ label, value, onChange, options }) {
    return (
        <div className="label-select-container">
            <label className="label-style">{label}</label>
            <select className="select-style" value={value} onChange={onChange}>
                {options.map(option => (
                    <option key={option.key} value={option.key}>{option.text}</option>
                ))}
            </select>
        </div>
    );
}

export function LabeledDateInput({ label, value, onChange }) {
    return (
        <div className="label-select-container">
            <label className="label-style">{label}</label>
            <input type="date" value={formatDate(value)} onChange={onChange} className="select-style" />
        </div>
    );
}